<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { Loader2 } from 'lucide-vue-next';
import { storeOrdersApiClient } from '@api-client/store_orders';
import { toast } from "@iframe-widgets/pages/widgets/toast/iframeToast";

const props = defineProps<{
    storeId: string;
    start?: number;
    end?: number;
}>();

const isLoading = ref(true);
const invoiceHtml = ref('');

onMounted(async () => {
    isLoading.value = true;
    const { data, error } = await (await storeOrdersApiClient[':storeId'].balance_invoice.$post({
        param: {
            storeId: props.storeId,
        },
        json: {
            start: props.start,
            end: props.end,
        }
    })).json();
    isLoading.value = false;

    if (error) {
        toast.error('Failed to load balance invoice');
        console.error(error);
        return;
    }
    if (!data) {
        toast.error('No invoice data');
        return;
    }
    invoiceHtml.value = data;
});
</script>

<template>
    <div class="flex h-full min-h-0 flex-col">
        <Loader2 v-if="isLoading"
                 class="animate-spin min-w-8 min-h-8 mx-auto my-8" />
        <iframe v-else-if="invoiceHtml"
                title="Balance invoice"
                class="min-h-0 w-full flex-1 border-0 bg-white"
                :srcdoc="invoiceHtml" />
    </div>
</template>
